import React from "react";

import styles from "./DefaultMeetingEventLogo.module.css";

const DefaultMeetingEventLogo = () => {
  return <div className={styles.wherebyEventLogo}></div>;
};

export default DefaultMeetingEventLogo;
